module.exports = __webpack_public_path__ + "static/media/IMG_9031.e2cd9508.JPG";